import { useProgressContext } from "providers/ProgressContext";
import { Button, ButtonSize } from "shared/components";
import { cx } from "shared/utils";
import { Check, Download01 } from "untitledui-js-base";
import { Card } from "./Card";

const bannerCustomization = ({
  success,
  error,
  fileName
}: {
  success: number;
  error: number;
  fileName: string;
}) => {
  if (error)
    return {
      text: (
        <p className="text-sm font-medium text-danger-500">
          <span className="block">
            Your uploaded file <span className="font-bold">{fileName}</span> has
            issues with its fields.
          </span>
          <span className="block">
            {success
              ? "You can proceed with the valid data or download the CSV file with highlighted errors to try to fix them"
              : "You can download the CSV file with highlighted errors to try to fix them"}
          </span>
        </p>
      ),
      bg: "bg-danger-50",
      Icon: (
        <div className="h-5 w-5 select-none rounded-full bg-danger-500 text-center text-sm font-bold text-white">
          !
        </div>
      )
    };

  return {
    text: (
      <p className="text-sm font-medium text-success-500">
        <span className="block">
          Your uploaded file <span className="font-bold">{fileName}</span> was
          successfully verified
        </span>
      </p>
    ),
    bg: "bg-success-50",
    Icon: (
      <div className="flex h-5 w-5 -translate-x-px select-none items-center justify-center rounded-full bg-success-500 text-center text-sm font-bold text-white">
        <Check className="stroke-white stroke-[2px]" size="14px" />
      </div>
    )
  };
};

export const Banner = () => {
  const { uploadCsv } = useProgressContext();

  const success = uploadCsv.meta?.data?.stats.valid_count || 0;
  const error = uploadCsv.meta?.data?.stats.invalid_count || 0;

  const { text, bg, Icon } = bannerCustomization({
    success,
    error,
    fileName: uploadCsv.meta?.data?.csv_filename || ""
  });

  return (
    <Card className={cx("mb-6 px-6 py-4", bg)}>
      <div className="flex items-center space-x-3">
        {Icon}
        <div className="ml-4 flex-1 border-l border-alpha-100 pl-4">{text}</div>
        {error ? (
          <a download href={uploadCsv.meta?.data?.result_csv_url}>
            <Button Icon={Download01} size={ButtonSize.SM}>
              Download CSV
            </Button>
          </a>
        ) : null}
      </div>
    </Card>
  );
};
